import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=19993e73&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=ts&"
export * from "./Bottom.vue?vue&type=script&lang=ts&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=19993e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19993e73",
  null
  
)

export default component.exports